import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { IStore } from 'src/redux/reducers';

// Memoized selectors for better performance
const selectDatasetData = createSelector(
  (state: IStore) => state.dataset,
  (state: IStore) => state.job.jobStatus.job,
  (dataset, job) => ({
    isJob: dataset.isJob,
    datasetId: dataset.isJob ? dataset.datasetID : dataset.id,
    jobId: dataset.isJob ? dataset.id : job?.jobId,
    isExistingDataset: dataset.isExistingDataset,
  })
);

const selectJobData = createSelector(
  (state: IStore) => state.job.jobStatus.job,
  (state: IStore) => state.dataset.jobDetails,
  (jobData, jobDetails) => ({ jobData, jobDetails })
);

const selectImageData = createSelector(
  (state: IStore) => state.dataset.images,
  (images) => images
);

const selectMappingData = createSelector(
  (state: IStore) => state.dataset.rejectionMapping,
  (state: IStore) => state.grainType.grainId,
  (rejectionMapping, grainId) => ({ rejectionMapping, grainId })
);

const selectUploadProgress = createSelector(
  (state: IStore) => state.dataset.uploadProgress,
  (state: IStore) => state.dataset.uploadCompleted,
  (uploadProgress, uploadCompleted) => ({ uploadProgress, uploadCompleted })
);

// Custom hooks using optimized selectors
export const useDatasetData = () => useSelector(selectDatasetData);
export const useJobData = () => useSelector(selectJobData);
export const useImageData = () => useSelector(selectImageData);
export const useMappingData = () => useSelector(selectMappingData);
export const useUploadProgress = () => useSelector(selectUploadProgress);